export default {
  alternativeButtonLabel: {
    id: 'alternative-button-label',
    defaultMessage: 'Slide',
  },
}
